import styled from 'styled-components';
import { Table } from 'antd';
import Color from '../../../enums/color';
const StyledTable = styled(Table) `
  & .ant-table {
    padding: 16px 32px;
  }

  & .ant-table .ant-table-container::before,
  .ant-table .ant-table-container::after {
    box-shadow: unset;
  }

  & .ant-table-thead > tr > th {
    font-family: 'Roboto';
    background: transparent;
    font-weight: bold;
    padding: 16px 10px;
  }

  & td.ant-table-cell {
    padding: 6px 10px;
  }

  & .ant-table-body {
    overflow-y: auto !important;
  }

  & .actions-column {
    color: ${Color.MicrosoftBlue};
  }

  & .ant-table-tbody > tr > td {
    font-weight: 500;
  }

  & .ant-table-tbody > tr.ant-table-row:hover > td {
    background: ${Color.HawkesBlue};
  }

  & th.ant-table-cell.with-subheader {
    padding-bottom: 0;
    border-bottom: unset;
  }

  & th.ant-table-cell.subheader {
    padding: 0 4px 12px;
    text-align: center;
    font-size: 14px;
  }

	& th svg {
		position: absolute;
		left: 100%;
		top: 50%;
		transform: translate(4px, -50%);
  }

	& td.center-column, 
	& th.center-column {
		text-align: center;
	}

	& td.right-column,
	& th.right-column {
		text-align: right;
	}

  @media screen and (max-width: 1500px) {
    & .ant-table table {
      width: ${props => `${props.scrollableTableWidth}px`};
    }
  }
`;
export default StyledTable;
